// extracted by mini-css-extract-plugin
export default {"slider__auth":"Slider__slider__auth___cqqWn"};